var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-4 mb-6 md:flex-none md:mb-0"},[_c('vue-recaptcha',{ref:"recaptcha",attrs:{"sitekey":_vm.recaptchaSiteKey},on:{"verify":_vm.onVerifyRecaptcha,"expired":_vm.onExpiredRecaptcha}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }